// Generated at:2024-07-17 09:55:30
export default {
    message: {
        "fail": "request fail",
        "server error..": "server error.",
        "duplicated request": "duplicated request",
        "invalid request parameter": "invalid request parameter",
        "missing access token": "missing access token",
        "invalid access token": "invalid access token",
        "you are forbidden to access the system": "you are forbidden to access the system",
        "you are forbidden to access the api": "you are forbidden to access the api",
        "BackMyAIS": "Back MyAIS",
        "Home": "Home",
        "Product": "Product",
        "Card": "Card",
        "DirectTopUp": "Direct Top Up",
        "MyAccount": "My Account",
        "Search": "Search",
        "SearchResult": "Search Result",
        "PopularSearchKeywords": "Popular Search Keywords",
        "AllProducts": "All Products",
        "All": "All",
        "Filter": "Filter",
        "WeCouldNotFindAnythingPleaseTrySomethingElse": "We could not find anything, please try something else.",
        "InputTheKeyword": "Type your search keywords for product and click search.",
        "NoMoreResult": "No More Result",
        "CardSelected": "Card Selected",
        "SelectCard": "Select Card",
        "TopupAmount": "Topup Amount",
        "SelectTopupAmount": "Select Topup Amount",
        "StockOut": "Stock Out",
        "PurchaseQuantity": "Purchase Quantity",
        "PurchaseLimit": "Purchase Limit",
        "PaymentChannel": "Payment Channel",
        "ProcessingFees": "Processing Fees",
        "SorryThisPaymentChannelIsTemporarilyUnavailable": "Sorry, This Payment Channel Is Temporarily Unavailable.",
        "EmailAddress": "E-mail Address",
        "YourE-mailAddress": "Your E-mail address",
        "Description": "Description",
        "Instruction": "Instruction",
        "OrderInformation": "Order Information",
        "PleaseFillInOrderInformation": "Please fill in order information",
        "Confirm": "Confirm",
        "PleaseInputYourEmail": "Please input your email",
        "PleaseConfirmTheContentsOfYourOrder": "Please confirm the contents of your order",
        "MyOrders": "My Orders",
        "Notification": "Notification",
        "LiveChat": "Live Chat",
        "RecentPurchases": "Recent purchases",
        "WaitSend": "Wait Send",
        "Sending": "Sending",
        "Refunded": "Refunded",
        "PartialRefund": "Partial Refund",
        "Closed": "Closed",
        "Completed": "Completed",
        "PayNow": "Pay Now",
        "OrderDetails": "Order details",
        "OriginalPriceTotal": "Price inclusive tax",
        "GSTInclusive": "GST Inclusive",
        "Inclusive": "Inclusive",
        "PaymentStatus": "Payment Status",
        "CreatedOn": "Created on",
        "ExpiredAfter": "Expired after",
        "Paid": "Paid",
        "Total": "Total",
        "RetrieveCode": "Retrieve Code",
        "ExpireDate": "Expire Date",
        "ClickToCopyTheTextContentToTheClipboard": "Click to copy the text content to the clipboard",
        "SendCard": "Please provide a valid email address so that we can send you the purchase details.",
        "SorryThisItemIsUnavailableInYourRegion": "Sorry! This item is unavailable in your region.",
        "FillEailAddress": "Please fill in your email address, and we will send the point card you purchased through this email address.",
        "Wishlist": "Wishlist",
        "CantFindWriteWishList": "Any games you wish to see but not available here?",
        "FillOutMyWishList": "Submit Wishlist",
        "WhatWouldYouLikeToBuyAtTheSEAGMMiniStore": "Please tell us any games you wish to see but not available here",
        "WeCollectWishServeYouBetter": "We will update more games in the future. Stay tune.",
        "Send": "Send",
        "OrderLiveChatTips": "If you have problems with your order, please contact online customer service.",
        "CustomerService": "Customer Service",
        "OrderConfirmation": "Order Confirmation",
        "OppoLoginTips": "Log in with your Heytap account for easy order tracking and history at any time.",
        "OppoGuestTips": "This order details will be sent to your provided email. Note: Please use a valid email address, as you can only inquire about order information through email or customer service. Your user information stored in cookies and no records retained.",
        "OppoRecommend": "Recommend",
        "LoginViaHeyTapAccount": "Login via HeyTap account",
        "PurchaseWithoutLogin": "Purchase without login",
        "HeyTapLogin": "HeyTap Login",
        "Continue": "Continue",
        "MyInvoice": "My Invoice",
        "Generate": "Generate",
        "Download": "Download",
        "GenerateInvoice": "Generate Invoice",
        "DownloadInvoice": "Download Invoice",
        "SelectPayment": "Select Payment",
        "FillInYourInformation": "Fill-in your information",
        "SubmitInvoiceInformation": "Submit Invoice Information",
        "NoDownloadInvoice": "There is no invoice available for download at the moment",
        "NoGenerateInvoice": "There are no invoicing orders available at the moment",
        "RecentlyUsed": "Recently Used",
        "InvoiceID": "Invoice ID",
        "GeneratedTime": "Generated Time",
        "PaymentID": "Payment ID",
        "GenerateInvoiceTips": "SEAGM e-invoices: Only completed payments are eligible for invoice issuance. Each payment can generate an e-invoice only once. To issue an invoice, please provide your tax information.",
        "Country": "Country",
        "State": "State",
        "City": "City",
        "CityName": "City Name",
        "Address": "Address",
        "YourAddress": "Your Address",
        "Identification": "Identification",
        "InputInvoicetype": "The value corresponding to the invoice type",
        "IdentificationNumber": "Identification number",
        "RequiredIdentificationNumber": "For Malaysian user, please enter the correct TIN Number,For non-Malaysian user, please use the default TIN Number EI00000000010",
        "PassportName": "Passport name",
        "RequiredBRN": "Correct business registration number",
        "RequiredArmy": "For Malaysian individual: MyKad / MyTentera identification number, For non-Malaysian individual: MyPR / MyKAS identification number",
        "Name": "Name",
        "Company": "Company",
        "YourName": "Your Name",
        "CompanyName": "Company Name",
        "TinNumber": "Tin Number",
        "MandatoryMalaysians": "It is mandatory for Malaysians and companies.",
        "RequiredSST": "Required if you are registered for SST. Example: B01-xxxx-xxxxxxxx",
        "PhoneNumber": "Phone",
        "YourContactNumber": "Your Contact Number",
        "Email": "Email",
        "YourEmail": "Your Email",
        "IFNotApplicable": "If not applicable, leave blank.",
        "PleaseInputCityName": "Please input city name",
        "PleaseInputYourName": "Please input your name",
        "PleaseInputIdentify": "Please input identify",
        "PleaseInputTin": "Please input tin",
        "PleaseInputAddress": "Please input address",
        "PleaseInputContactNumber": "Please input contact number",
        "PleaseSelectPayment": "Please select Payment",
        "CantDownLoadInvoice": "If you are unable to download the invoice. Please copy the following address and open it in your browser to download the invoice.",
        "CopyURL": "Copy URL",
        "Close": "Close",
        "CopySuccess": "Copy Success",
        "CopyFail": "Copy Fail",
        "NRICNumber": "NRIC Number must be a 12-digit number"
    }
}